// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { ReactNode } from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

export interface SummaryLine { key: string; label: ReactNode; value: ReactNode; strong?: boolean; muted?: boolean }

/** D-UI-3 — a short label / amount ledger (a subtotal block), not a data list. Lists use DataGrid. */
export default function SummaryLines({ lines, maxWidth = 520 }: { lines: SummaryLine[]; maxWidth?: number }) {
  return (
    <Table size="small" sx={{ maxWidth }}>
      <TableBody>
        {lines.map(l => (
          <TableRow key={l.key}>
            <TableCell sx={{ pl: 0, fontWeight: l.strong ? 800 : 400, color: l.muted ? 'text.secondary' : undefined }}>{l.label}</TableCell>
            <TableCell align="right" sx={{ fontWeight: l.strong ? 800 : 400, fontVariantNumeric: 'tabular-nums', color: l.muted ? 'text.secondary' : undefined }}>{l.value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
